/*
 * ParticipantListFrameContainer.jsx 30.01.18
 *
 * (c) 2018 ergovia GmbH
 */

import React from 'react';
import {compose, graphql} from 'react-apollo';
import ParticipantListItem from '../../components/participants/ParticipantListItem';
import getParticipantsQuery from '../../queries/getParticipantByIdSimple.graphql';


const withParticipants = graphql(getParticipantsQuery, {
    options: params => ({
        variables: {teilnehmerId: parseInt(params.participant.id, 10)},
        fetchPolicy: 'cache-and-network',
        pollInterval: 60000
    }),
    props: ({ownProps, data }) => {

        if (data.loading || data.error) {
            return {
                refetchData: () => {
                    // notwendig, falls beim Laden der Daten bereits in ParticipantListItem der FocusListener aufgerufen wird.
                },
                data: {
                    ziele : null
                }
            };
        }

        return {
            refetchData: data.refetch,
            participant: ownProps.participant,
            data: data.getTeilnehmerById
        };
    }
});


class ParticipantListItemContainer extends React.Component {

    componentWillReceiveProps(nextProps) {
        if (nextProps.data && nextProps.data.ziele && nextProps.participant.ziele && nextProps.participant.ziele.length !== nextProps.data.ziele.length) {
            this.props.onGoalDataLoaded(nextProps.data);
        }
    }

    render() {
        return (
            <ParticipantListItem {...this.props} />
        );
    }
}


export default compose(withParticipants)(ParticipantListItemContainer);



// WEBPACK FOOTER //
// ./src/de/ergovia/containers/participants/ParticipantListItemContainer.js